import { VersionTimeline, type VersionEntry } from "@/components/domain/version-timeline"

const versions: VersionEntry[] = [
  {
    label: "v3",
    printedOn: "2026-08-22",
    uploadedAgo: "2h ago",
    current: true,
    delta: { fixed: 7, open: 5, regressed: 1 },
  },
  {
    label: "v2",
    printedOn: "2026-08-14",
    uploadedAgo: "8 days ago",
    reportSentOn: "2026-08-15",
    delta: { fixed: 3, open: 9, regressed: 0 },
  },
  {
    label: "v1",
    printedOn: "2026-07-30",
    reportSentOn: "2026-08-01",
    findingCount: 12,
  },
]

export function VersionTimelinePreviewRoute(): JSX.Element {
  return (
    <div className="mx-auto max-w-4xl px-8.5 py-11">
      <header className="mb-8">
        <div className="font-id text-eyebrow uppercase tracking-[0.16em] text-text-3">
          Domain component
        </div>
        <h1 className="mt-1 text-display text-text">VersionTimeline</h1>
        <p className="mt-2 max-w-2xl text-body text-text-2">
          The delta triad is the whole point: <em>fixed / still open / came back</em>.
        </p>
      </header>

      <div className="rounded-lg border border-border bg-surface p-4 shadow-e1">
        <VersionTimeline
          versions={versions}
          onOpen={(label, current) => {
            // eslint-disable-next-line no-console
            console.info("open version", label, { current })
          }}
        />
      </div>

      <h2 className="mb-3.5 mt-8 font-id text-caption uppercase tracking-[0.16em] text-text-3">
        Compact (no delta column)
      </h2>
      <div className="rounded-lg border border-border bg-surface p-4 shadow-e1">
        <VersionTimeline versions={versions} compact />
      </div>
    </div>
  )
}
